<script lang="ts" setup>
import {useTranslation} from "i18next-vue";
import { computed } from 'vue'

import ProfilesIcon from '@/assets/icons/briefcase.svg'
import CarIcon from '@/assets/icons/car-side.svg'
import JobsIcon from '@/assets/icons/clipboard.svg'
import DashboardIcon from '@/assets/icons/dashboard.svg'
import InvoiceIcon from '@/assets/icons/file-text.svg'
import LogoutIcon from '@/assets/icons/logout.svg'
import CustomersIcon from '@/assets/icons/user.svg'
import UsersIcon from '@/assets/icons/user-group.svg'
import {useUserStore} from '@/stores/user-store'

defineProps<{
  isSidebarExpanded: boolean
}>()

const emit = defineEmits(['link-clicked'])
const userStore = useUserStore()
const { t } = useTranslation()

const handleMobileLinkClick = () => {
  if (window.innerWidth <= 991) {
    emit('link-clicked')
  }
}

const { signOut } = userStore

// Computed per verificare se l'utente è admin o cliente
const isAdmin = computed(() => userStore.user?.tipo === 'admin')
const isCliente = computed(() => userStore.user?.tipo === 'cliente')
</script>

<template>
  <aside class="layout-menu flex flex-col gap-4 h-full">
    <!-- Menu per Admin -->
    <div v-if="isAdmin" class="flex flex-col gap-4">
      <RouterLink class="admin-link" to="/admin" @click="handleMobileLinkClick">
        <DashboardIcon />
        <span v-if="isSidebarExpanded">{{ t('common:dashboard') }}</span>
      </RouterLink>

      <RouterLink class="admin-link" to="/admin/profili" @click="handleMobileLinkClick">
        <ProfilesIcon />
        <span v-if="isSidebarExpanded">{{ t('common:profiles') }}</span>
      </RouterLink>

      <RouterLink class="admin-link" to="/admin/utenti" @click="handleMobileLinkClick">
        <UsersIcon />
        <span v-if="isSidebarExpanded">{{ t('common:users') }}</span>
      </RouterLink>

      <RouterLink class="admin-link" to="/admin/clienti" @click="handleMobileLinkClick">
        <CustomersIcon />
        <span v-if="isSidebarExpanded">{{ t('common:customers') }}</span>
      </RouterLink>

      <RouterLink class="admin-link" to="/admin/vetture" @click="handleMobileLinkClick">
        <CarIcon />
        <span v-if="isSidebarExpanded">{{ t('common:vettura.vetture') }}</span>
      </RouterLink>

      <RouterLink class="admin-link" to="/admin/lavori" @click="handleMobileLinkClick">
        <JobsIcon />
        <span v-if="isSidebarExpanded">{{ t('common:jobs') }}</span>
      </RouterLink>

      <RouterLink class="admin-link" to="/admin/fatture" @click="handleMobileLinkClick">
        <InvoiceIcon />
        <span v-if="isSidebarExpanded">{{ t('common:fattura.fatture') }}</span>
      </RouterLink>
    </div>

    <!-- Menu per Cliente -->
    <div v-else-if="isCliente" class="flex flex-col gap-4">
      <RouterLink class="admin-link" to="/cliente" @click="handleMobileLinkClick">
        <DashboardIcon />
        <span v-if="isSidebarExpanded">{{ t('common:dashboard') }}</span>
      </RouterLink>

      <RouterLink class="admin-link" to="/cliente/vetture" @click="handleMobileLinkClick">
        <CarIcon />
        <span v-if="isSidebarExpanded">{{ t('common:vettura.vetture') }}</span>
      </RouterLink>
    </div>

    <div class="mt-auto">
      <button class="admin-link" @click="() => signOut(true)">
        <LogoutIcon />
        <span v-if="isSidebarExpanded">{{ t('common:logout') }}</span>
      </button>
    </div>
  </aside>
</template>

<style lang="scss" scoped>
.admin-link {
  @apply flex gap-4 hover:bg-neutral-100 px-4 py-3 w-full rounded-xl;

  &.router-link-exact-active {
    @apply bg-brand-primary text-white;
  }
}
</style>
